export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const COLORS = {
  // App backgrounds
  bg:              '#060402',
  bgSecondary:     '#080604',

  // Card surfaces
  bgCard:          '#0F0C07',   // was #060402 — now distinct from bg, fixes flatness
  bgCardTop:       '#1A1510',   // was #0D0B09 — warmer lift
  bgCardElevated:  '#110F0D',

  // Borders
  border:          'rgba(144, 115, 85, 0.12)',
  borderStrong:    '#42372E',

  // Fill Bar / Bourbon Gold
  accent:          '#B88640',
  accentLight:     '#D4A76A',
  accentDark:      '#7A5218',

  // Fill bar
  fillBarStart:    '#5C2E0E',
  fillBarMid:      '#9B4E1A',
  fillBarEnd:      '#C47A35',

  // Add Button (The "Pop" element)
  addBtnTop:       '#D4A76A',
  addBtnBottom:    '#9C753C',

  // Text
  text:            '#F5E9D0',
  textMuted:       '#BFAE8F',
  textDim:         '#8A7A5C',

  // Status
  statusSealed:    'rgba(46, 74, 55, 0.4)',
  statusOpen:      'rgba(145, 105, 45, 0.3)',
  statusAllocated: 'rgba(125, 55, 45, 0.35)',
  statusEmpty:     'rgba(60, 55, 50, 0.5)',

  // Semantic
  red:             '#C0504A',
  green:           '#4A7A52',

  // Section banners — Home screen
  bannerCrown:     '#2A1A06',   // deep amber — Crown Jewels header
  bannerPours:     '#1A1506',   // deep gold — Best Pours header
  bannerDNA:       '#0E1620',   // deep blue-grey — Taste DNA header
  bannerLastPour:  '#1E1609',   // warm dark — Last Pour header

  // Glow
  glowAmber:       'rgba(184, 134, 64, 0.15)',
};